import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Title from '@/components/Title';
import ReviewCardGrid from '@/components/WukongReviews/ReviewCardGrid';

/**
 * 口碑之选模块 - Math
 * 展示 Trustpilot 好评（数据来自 wallOfLove）
 */
const GoodReputation: React.FC = () => {
  const { t, i18n } = useTranslation(['math']);

  return (
    <div className="mx-auto mt-[80px] lg:mt-[130px] xl:mt-[46px]">
      {/* 标题 */}
      <div className="container">
        <Title innerHTML theme="math">
          {t('口碑-标题')}
        </Title>
      </div>

      {/* 评分条 + 好评卡片 */}
      <ReviewCardGrid subject="math" />

      {/* Explore more 按钮 */}
      <div className="text-center">
        <Button
          size="xl"
          className="mt-6 lg:mt-12 xl:mt-[60px] [&]:text-base [&]:font-medium [&]:xl:text-xl"
          onClick={() => {
            const path =
              i18n.language === 'zh'
                ? '/zh/wukong-reviews/#reviews'
                : '/wukong-reviews/#reviews';
            window.location.href = path;
          }}>
          {t('口碑-按钮')}
        </Button>
      </div>
    </div>
  );
};

export default GoodReputation;
